import {
  GET_LIABLITY_INFORMATION,
  GET_SELECTED_LIABLITY_INFORMATION,
  GET_Liablity_TYPE_INFORMATION,
  GET_Liablity_ENTITY_INFORMATION,
  GET_LOAN_CHART_MODEL,
  GET_ICE_API_RESPONSE,
  GET_COMPARE_LOAN_INFO,
  GET_ICE_PROJECTION_MODEL,
} from "../../../helpers/vuex-constants";

export default {
  [GET_LIABLITY_INFORMATION](state) {
    return state.loandata;
  },

  [GET_SELECTED_LIABLITY_INFORMATION](state) {
    return state.selectedLoan;
  },
  [GET_Liablity_TYPE_INFORMATION](state) {
    return state.loanType;
  },
  [GET_Liablity_ENTITY_INFORMATION](state) {
    return state.loanEntitiesInfo;
  },
  [GET_ICE_PROJECTION_MODEL](state) {
    return state.iceProjectionModel;
  },
  [GET_ICE_API_RESPONSE](state) {
    return state.iceAPIResponse;
  },
  [GET_LOAN_CHART_MODEL](state) {
    return state.loanInput;
  },
  [GET_COMPARE_LOAN_INFO](state) {
    return state.compareLoans;
  },
};
